import React from 'react';

const FirstBookingOnboardingModal = ({ translations = {}, onClose }) => {
  const t = translations.bookings?.first_booking_onboarding || {};

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 lg:p-4">
      <div className="bg-white w-full h-full lg:h-auto lg:max-h-[90vh] lg:max-w-lg lg:mx-4 lg:rounded-xl lg:shadow-xl overflow-hidden flex flex-col">
        {/* Header */}
        <div className="px-6 py-4 border-b" style={{ backgroundColor: '#E6F0FF', color: '#3366FF' }}>
          <h2 className="text-lg font-semibold">
            {t.title || 'First Lesson Booked!'}
          </h2>
        </div>

        {/* Body */}
        <div className="p-6 flex-1 overflow-y-auto">
          <div className="flex flex-col items-center text-center">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
              <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <p className="text-gray-700 text-base leading-relaxed mb-6">
              {t.body || 'You can view all your upcoming lessons and track your learning progress right here.'}
            </p>
            <a
              // eslint-disable-next-line no-restricted-syntax -- the backstage has no locale routes, so a prefix here is a 404
              href="/student/dashboard"
              className="inline-flex items-center gap-2 px-6 py-2.5 rounded-lg text-white font-medium transition-colors"
              style={{ backgroundColor: '#3366FF' }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#2952CC'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#3366FF'}
            >
              {t.cta || 'Go to Dashboard'}
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </a>
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t">
          <div className="flex justify-end">
            <button
              onClick={onClose}
              className="text-sm text-gray-400 hover:text-gray-600 transition-colors"
            >
              {t.dismiss || 'Close'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FirstBookingOnboardingModal;
